<template>
  <div class="topbar-item">
    <!-- Trigger button -->
    <div class="user_profile_quick" id="kt_quick_user_toggle">
      <span class="user-name">{{ currentUser.u.first_name }}</span>
      <div class="user-avatar">{{ currentUser.u.first_name | twoLetter }}</div>
    </div>

    <!-- Slide panel -->
    <div id="kt_quick_user" ref="kt_quick_user" class="offcanvas offcanvas-right">
      <div class="offcanvas-header d-flex align-items-center justify-content-between">
        <h3 class="m-0">Account</h3>
        <button class="btn-close-panel" id="kt_quick_user_close" ref="menuclose">
          <i class="ki ki-close"></i>
        </button>
      </div>

      <perfect-scrollbar class="offcanvas-content scroll" style="max-height: 90vh; position: relative;">
        <div class="user-panel">
          <div class="user-panel__identity">
            <div class="user-panel__avatar">{{ currentUser.u.first_name | twoLetter }}</div>
            <div class="user-panel__name">{{ currentUser.u.username }}</div>
            <div class="user-panel__email">{{ currentUser.u.email }}</div>
          </div>

          <button class="panel-btn" @click="profile">
            <i class="fa fa-key"></i> Change Password
          </button>
          <button class="panel-btn" @click="profile">
            <i class="fa fa-user"></i> Profile
          </button>
          <button class="panel-btn signout" @click="onLogout" v-if="!currentUser.i">
            <i class="fa fa-sign-out"></i> Sign Out
          </button>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.user_profile_quick {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .user-name {
    font-size: 13px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.85);
    display: none;
    @media (min-width: 768px) { display: block; }
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 8px;
    background: #389ad4;
    border: 2px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.5px;
  }
}

.offcanvas {
  width: 280px !important;
  background: #fff;

  .offcanvas-header {
    background: #389ad4;
    padding: 20px;
    border-bottom: none;

    h3 {
      color: #fff;
      font-size: 15px;
      font-weight: 600;
    }

    .btn-close-panel {
      width: 28px;
      height: 28px;
      border-radius: 6px;
      background: rgba(255,255,255,0.1);
      border: none;
      color: rgba(255,255,255,0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background 0.2s;

      &:hover { background: rgba(255,255,255,0.2); color: #fff; }
    }
  }

  .user-panel {
    padding: 24px 20px;

    .user-panel__identity {
      margin-bottom: 24px;
      padding-bottom: 20px;
      border-bottom: 1px solid #eef0f8;
    }

    .user-panel__avatar {
      width: 52px;
      height: 52px;
      border-radius: 12px;
      background: linear-gradient(135deg, #1E6FB8, #389ad4);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 700;
      color: #fff;
      margin-bottom: 12px;
    }

    .user-panel__name {
      font-size: 15px;
      font-weight: 700;
      color: #0d1b3e;
      margin-bottom: 2px;
    }

    .user-panel__email {
      font-size: 12px;
      color: #7a8499;
    }

    .panel-btn {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      padding: 10px 14px;
      border-radius: 8px;
      border: 1px solid #eef0f8;
      background: #fff;
      color: #0d1b3e;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
      margin-bottom: 8px;
      text-align: left;

      i { color: #389ad4; font-size: 14px; width: 16px; }

      &:hover {
        background: #eef2fb;
        border-color: #c5d4f0;
      }

      &.signout {
        color: #c62828;
        border-color: #fde8e8;
        i { color: #c62828; }
        &:hover { background: #fef5f5; border-color: #f5c6c6; }
      }
    }
  }
}
</style>

<script>
import { LOGOUT } from "../../../core/services/store/actions.type";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "../offcanvas/QuickPanel";
import { mapGetters } from "vuex";
import { nextTick } from "vue";

export default {
  name: "KTQuickUser",
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
  },
  methods: {
    onLogout() {
      this.$store.dispatch(LOGOUT).then(() => {
        window.localStorage.removeItem("appoitmentsearch");
        window.localStorage.removeItem("showNotificationModal");
        this.$router.push({
          name: "client.login",
          params: { client_slug: this.$route.params.client_slug }
        });
        nextTick(() => {
          window.location.reload();
        });
      });
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
    profile() {
      if (this.currentUser.u.is_admin == 1) {
        this.$router.push({
          name: "admin.profile"
        });
      } else {
        this.$router.push({
          name: "client.profile",
          params: { client_slug: this.$route.params.client_slug }
        });
      }
      this.$refs.menuclose.click();
    }
  },

  computed: {
    picture() {
      return process.env.BASE_URL + "media/users/300_21.jpg";
    },
    ...mapGetters(["currentUser"])
  },
  filters: {
    twoLetter: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.charAt(1).toUpperCase();
    }
  }
};
</script>
